module.exports = __webpack_public_path__ + "static/media/blueRadioActive.bbe499d0.svg";